import axios from "axios";

export async function getExchangeAmount(amount) {
  try {
    const { data } = await axios.get(
      "https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json"
    );

    const rate = data.find((item) => item.cc === "USD")?.rate;

    if (!rate) {
      throw new Error(`Exchange rate for ${currency} not found.`);
    }

    return Number((amount * rate).toFixed(2));
  } catch (error) {
    console.error("Failed to fetch exchange rate:", error);
    throw error;
  }
}
